<template>
    <div id="StoryTitle">
        <div class="block-title-container d-flex flex-row justify-content-center align-items-center">
            <IconButton :on-click="() => $router.push('/chatbot/stories')">
                <span class="material-icons cb-back-button"> chevron_left </span>
            </IconButton>
            <input
                ref="editStoryName"
                :placeholder="$t('chatbotv2.typeStoryTitle')"
                :value="storyName"
                @input="storyName = $event.target.value"
                @blur="updateName()"
            />
            <div class="representative-container">
                <a-button
                    v-for="user in filteredChatbotStoryViewActivity"
                    :key="user.userId"
                    v-tippy="{ content: users[user.userId].name }"
                    placement="bottom"
                >
                    <span class="representative-online"></span>
                    {{ users[user.userId].name.substring(0, 10) + "..." }}
                </a-button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import IconButton from "../../../../Settings/components/IconButton.vue";
import { sendSocketMessage } from "../../../../../../utils/socketStream";

export default {
    name: "StoryTitle",
    components: { IconButton },
    props: ["storyTitle", "storyId"],
    data() {
        return {
            storyName: this.storyTitle,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            users: (state) =>
                state.user.users.data.reduce(
                    (acc, user) => ({
                        ...acc,
                        [user._id]: user,
                    }),
                    {}
                ),
            stories: (state) => state.CB.stories,
            chatbotStoryViewActivity: (state) => state.app.chatbotStoryViewActivity,
            site: (state) => state.site.site,
        }),
        filteredChatbotStoryViewActivity() {
            return this.chatbotStoryViewActivity.filter(
                (user) => user.storyId === this.storyId && user.updateTS > Date.now() - 1000 * 10
            );
        },
    },
    methods: {
        ...mapActions({
            updateStoryName: "CB/updateStoryName",
        }),
        updateName() {
            if (this.storyTitle !== this.storyName) {
                const name = this.storyName.trim();
                this.updateStoryName({
                    id: this.storyId,
                    title: name,
                }).then(() => {
                    sendSocketMessage("chatbot/v2 name-changed", {
                        siteId: this.site._id,
                        storyId: this.storyId,
                        name,
                    });
                });
            }
        },
    },
};
</script>

<style lang="scss">
#StoryTitle {
    .cb-back-button {
        font-size: 40px !important;
    }

    .block-title-container {
        gap: 10px;

        input {
            background: none;
            border: 0;
            font-size: 22px;
            font-weight: 600;
            line-height: 28px;
            width: 100%;
            font-family: Source Sans Pro, sans-serif;
            cursor: context-menu;
        }
    }

    .representative-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;

        .representative-online {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #00ff00;
            margin-right: 10px;
        }
    }

    .representative-name {
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        display: -webkit-box;
    }

    .ant-btn:hover,
    .ant-btn:focus {
        color: #595959;
        background-color: #fff;
        border-color: #d9d9d9;
    }
}
</style>
